/**
 * React-Query-Hook fuer den QuickSight-Embed-Mint (Spec 429 Increment D).
 *
 * Die gemintete Embed-URL ist kurzlebig (Single-Use, ~5 Min Einloese-Fenster), daher KEIN
 * Caching ueber die Frische hinaus: staleTime 0, kein Retry auf 503 (der „noch nicht
 * verfuegbar"-Pilot-Zustand ist kein transientes Problem, das ein Retry loest).
 */
import { useQuery } from '@tanstack/react-query';
import { fetchReportEmbedUrl, type ReportKey } from '@/lib/api/reports';
import { ApiError } from '@/lib/api/client';

export function useReportEmbed(reportKey: ReportKey, enabled = true) {
  return useQuery({
    queryKey: ['report-embed', reportKey],
    queryFn: () => fetchReportEmbedUrl(reportKey),
    enabled,
    staleTime: 0,
    gcTime: 0,
    retry: (failureCount, error) => {
      // 503 (Pilot-dunkel / dashboardId noch nicht publiziert) und 403 (nicht entitled)
      // sind stabile Zustaende → nicht wiederholen. Nur echte Transient-Fehler max. 1×.
      if (error instanceof ApiError && [403, 404, 503].includes(error.status)) return false;
      return failureCount < 1;
    },
  });
}
